import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from '@services/index';
import { PollLauncherComponent } from './polls/components/index';
import { PageNotFoundComponent } from './not-found.component';
import { EulaComponent } from './eula/eula.component';

const routes: Routes = [
  {
    path: 'admin',
    loadChildren: 'app/admin/admin.module#AdminModule',
    canActivateChild: [ AuthGuardService ],
    data: {
      permitted: [ 'admin' ]
    }
  },
  {
    path: 'launcher',
    component: PollLauncherComponent,
    pathMatch: 'full',
    canActivate: [ AuthGuardService ],
    data: {
      permitted: [ 'student' ]
    }
  },
  {
    path: 'poll',
    loadChildren: 'app/polls/polls.module#PollsModule',
    canActivateChild: [ AuthGuardService ],
    data: {
      permitted: [ 'student' ]
    }
  },
  {
    path: 'eula',
    component: EulaComponent,
  },
  {
    path: 'forbidden',
    component: PageNotFoundComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
    canActivate: [ AuthGuardService ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class RouteModule {
  constructor(){}
}
